import { render, staticRenderFns } from "./TagContent.vue?vue&type=template&id=3f4b4344"
import script from "./TagContent.vue?vue&type=script&lang=js"
export * from "./TagContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports